// @flow
import * as Types from "./actionTypes";

type State = {
  loginNotification: string,
  redirectURL: string,
  requestedRedirect: boolean,
  requestFullfilled: boolean
};

type Action = {
  type: string,
  response: Object,
  payload: Object,
  status?: number
};

const initialState: State = {
  loginNotification: Types.NO_NOTIFICATION,
  redirectURL: "",
  requestedRedirect: false,
  requestFullfilled: false
};

export default function LoginReducer(
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case Types.RESET:
      return {
        ...state,
        ...initialState
      };
    case Types.NO_NOTIFICATION:
    case Types.LOGGED_OUT_WARNING_NOTIFICATION:
    case Types.SIGNED_OUT_SUCCESSFULLY_NOTIFICATION:
    case Types.INCORRECT_CREDENTIALS_NOTIFICATION:
    case Types.PASSWORD_EXPIRED_NOTIFICATION:
    case Types.SERVER_ERROR_NOTIFICATION:
      return {
        ...state,
        loginNotification: action.type
      };
    case Types.REQUEST_ACTION_TYPE:
      return {
        ...state,
        loginNotification: Types.NO_NOTIFICATION,
        requestedRedirect: true
      };
    case Types.SUCCESS_ACTION_TYPE: {
      const { auth_code_url: url } = action.response;
      return {
        ...state,
        redirectURL: url,
        requestFullfilled: true
      };
    }
    case Types.FAILURE_ACTION_TYPE: {
      let bannerNotificationType;
      const { status, payload = {} } = action;
      const { sentPass } = payload;
      switch (status) {
        case 403:
          if (!sentPass) {
            return {
              ...state,
              requestFullfilled: true
            };
          }
          bannerNotificationType = Types.INCORRECT_CREDENTIALS_NOTIFICATION;
          break;
        case 401:
          bannerNotificationType = Types.INCORRECT_CREDENTIALS_NOTIFICATION;
          break;
        default:
          bannerNotificationType = Types.SERVER_ERROR_NOTIFICATION;
      }
      return {
        ...state,
        loginNotification: bannerNotificationType
      };
    }
    default:
      return state;
  }
}
